// src/components/Layout/NotFound.js
import React from 'react';
import { Link } from 'react-router-dom';
import { Home, ArrowLeft, FileSearch } from 'lucide-react';

const NotFound = () => {
  return (
    <div className="flex items-center justify-center min-h-96">
      <div className="text-center max-w-md mx-auto">
        <div className="mb-8">
          <FileSearch className="w-24 h-24 text-gray-400 mx-auto mb-6" />
          <h1 className="text-6xl font-bold text-gray-900 mb-4">404</h1>
          <h2 className="text-2xl font-semibold text-gray-700 mb-4">Page Not Found</h2>
          <p className="text-gray-600 mb-8">
            Sorry, we couldn't find the page you're looking for. The page might have been moved, 
            deleted, or you may have entered an incorrect URL.
          </p>
        </div>

        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Link
            to="/"
            className="bg-indigo-600 text-white px-6 py-3 rounded-lg font-medium hover:bg-indigo-700 transition-colors flex items-center justify-center"
          >
            <Home className="w-5 h-5 mr-2" />
            Go to Dashboard
          </Link>
          
          <button
            onClick={() => window.history.back()}
            className="bg-gray-600 text-white px-6 py-3 rounded-lg font-medium hover:bg-gray-700 transition-colors flex items-center justify-center"
          >
            <ArrowLeft className="w-5 h-5 mr-2" />
            Go Back
          </button>
        </div>

        <div className="mt-8 pt-8 border-t border-gray-200">
          <p className="text-sm text-gray-500">
            Need help? Contact our support team or check our documentation.
          </p>
        </div>
      </div>
    </div>
  );
};

export default NotFound;